"use client"
import { useEffect, useRef } from "react"
import { BrowserMultiFormatReader, IScannerControls } from "@zxing/browser"

interface QRScannerProps {
  onScanSuccess: (code: string) => void
  onClose: () => void
}

const QRScanner: React.FC<QRScannerProps> = ({ onScanSuccess, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const controlsRef = useRef<IScannerControls | null>(null)

  const playBeep = () => {
    const beep = new Audio("/sounds/beep.mp3")
    beep.play().catch(console.error)
  }

  const vibrate = () => {
    if (navigator.vibrate) navigator.vibrate(200)
  }

  useEffect(() => {
    const codeReader = new BrowserMultiFormatReader()

    codeReader.decodeFromVideoDevice(
      undefined,
      videoRef.current!,
      (result, error, controls) => {
        if (result) {
          playBeep()
          vibrate()
          onScanSuccess(result.getText())
          controls.stop()
          onClose()
        }
      }
    ).then((controls) => {
      controlsRef.current = controls
    })

    return () => {
      controlsRef.current?.stop()
    }
  }, [onScanSuccess, onClose])

  return (
    <div className="fixed inset-0 bg-black/70 z-[1100] flex flex-col items-center justify-center px-4">
      <p className="text-white mb-4 text-sm text-center">
        Otorga permiso de cámara para escanear el código QR o de barras
      </p>
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg overflow-hidden">
        <video ref={videoRef} className="w-full h-auto" />
      </div>
      <button
        onClick={() => {
          controlsRef.current?.stop()
          onClose()
        }}
        className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
      >
        Cancelar
      </button>
    </div>
  )
}

export default QRScanner
